import React, { useContext } from 'react';
import useSweetAlert from '../../../hooks/useSweetAlert';
import { DispatchProgramItemStatus } from '../../../app/models/DispatchProgramItem';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useDispatchProgramItemService from '../../../app/services/hooks/useDispatchProgramItemService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';

interface Props {
    dispatchProgramItemId: number;
    statuses: DispatchProgramItemStatus[];
    selectedStatus: DispatchProgramItemStatus;
    callbackSuccess?: () => void;
    reloadModule: () => void;
}

const DispatchProgramItemChangeStatus = ({
    dispatchProgramItemId,
    statuses,
    selectedStatus,
    reloadModule,
    callbackSuccess
}: Props) => {
    const [selected, setSelected] = React.useState<DispatchProgramItemStatus>(selectedStatus);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const {
        preparationDispatchProgramItem,
        planningDispatchProgramItem,
        dispatchDispatchProgramItem,
        finishDispatchProgramItem,
        annulledDispatchProgramItem,
        hasAllFinishedDispatchProgramItems
    } = useDispatchProgramItemService();

    // useEffect(() => {
    //     if (status === ResponseStatus.SUCCESS) {
    //         if (callbackSuccess) {
    //             callbackSuccess();
    //         }
    //         useSweetAlert().successAlert({
    //             title: 'Éxito',
    //             text: 'Se ha cambiado el estado del despacho #' + quoteId
    //         });
    //     }
    // }, [status]);

    const eventChangeStatus = {
        onSuccess: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
                reloadModule();
            }
    
            useReactConfirmAlert().successAlert({
                title: 'Éxito',
                message: `Se ha cambiado el estado del item de despacho #${dispatchProgramItemId}`
            });
        },
        onError: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
            }
            toast.error(response.message);
        }
    };
    
    const changeStatus = (value: string) => {
        if (value === selected.id) return;
    
        const _status = statuses.find((status: DispatchProgramItemStatus) => status.id === value);
        setSelected(_status!);
    
        let _text = `Está a punto de cambiar el estado de item de despacho #${dispatchProgramItemId} a ${_status ? (_status.name === 'Despacho' ? 'Despachado' : _status.name) : ''}.`;
    
        if (showLoading) showLoading('loading', 'Verificando el estado del despacho...');
    
        hasAllFinishedDispatchProgramItems(dispatchProgramItemId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                if (response.data.has_all_finished_dispatch_program_items) {
                    _text += ` ${response.data.message}`;
                }
    
                useReactConfirmAlert().requestConfirmation({
                    title: '¿Está seguro?',
                    message: _text,
                    buttons: {
                        confirmButton: {
                            label: 'Sí, cambiar estado',
                            onClick: () => {
                                console.log("VALUE:", value); // esto justo antes del switch

                                switch (value) {
                                    case 'PREPARACION':
                                        preparationDispatchProgramItem(dispatchProgramItemId, eventChangeStatus);
                                        break;
                                    case 'PLANIFICACION':
                                        planningDispatchProgramItem(dispatchProgramItemId, eventChangeStatus);
                                        break;
                                    case 'DESPACHO':
                                        dispatchDispatchProgramItem(dispatchProgramItemId, eventChangeStatus);
                                        break;
                                    case 'FINALIZADO':
                                        finishDispatchProgramItem(dispatchProgramItemId, eventChangeStatus);
                                        break;
                                    case 'ANULAR':
                                        annulledDispatchProgramItem(dispatchProgramItemId, eventChangeStatus);
                                        break;
                                    default:
                                        useReactConfirmAlert().errorAlert({
                                            title: 'Error',
                                            message: 'Opción no encontrada.'
                                        });
                                        setSelected(selectedStatus);
                                        break;
                                }
                            }
                        },
                        cancelButton: {
                            label: 'No, cancelar',
                            onClick: () => {
                                setTimeout(() => {
                                    useReactConfirmAlert().infoAlert({
                                        title: 'Cancelado',
                                        message: 'El estado de item de despacho no se ha cambiado.'
                                    });
                                }, 0);
                                setSelected(selectedStatus); 
                            }
                        }
                    },
                    onClickOutsideFunction: () => {
                        setSelected(selectedStatus); 
                    }
                });
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                setSelected(selectedStatus);
            }
        });
    };
    
    
    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(e.target.value)}
        >
            <option value={selectedStatus.id}>{selectedStatus.name}</option>
            {statuses.map((status) => {
                return (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                );
            })}
        </select>
    );
};

export default DispatchProgramItemChangeStatus;
